<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <!-- Date -->
          <validation-provider
            #default="validationContext"
            name="date"
            rules="required"
          >
            <b-form-group
              label="Date"
              label-for="date"
            >
              <b-form-input
                id="date"
                v-model="auditDate"
                type="date"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Select date"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="12">
          <!-- Engineer -->
          <validation-provider
            #default="validationContext"
            name="engineer"
            rules="required"
          >
            <b-form-group
              label="Engineer"
              label-for="engineer"
            >
              <v-select
                id="engineer"
                :state="getValidationState(validationContext)"
                multiple
                trim
                placeholder="Select engineer"
                :options="optionUser"
                @input="showBoxForSelected"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          v-for="(userInfo, index) in usersBox"
          :key="index"
          md="6"
        >
          <div style="border: 1px solid #d8d6de; padding: 10px; border-radius: 4px; margin: 5px 0px;">
            <p>{{ userInfo.label }}</p>
            <b-form-select
              :id="`usersJob${index}`"
              v-model="userInfo.job"
              :options="optionsJob"
              @change="syncUsersPayload"
            />
            <div class="mt-1">
              <v-select
                :id="`usersType${index}`"
                v-model="userInfo.type"
                :options="optionstypes"
                trim
                placeholder="Select type"
                @input="syncUsersPayload"
              />
            </div>
          </div>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="AssignDateAndEng"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="AssignDateAndEng"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
// import _ from 'lodash'
// import decryptData from '@/store/auth/decryptData'

// eslint-disable-next-line no-unused-vars

export default {
  components: { vSelect },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      allSelected: [],
      usersBox: [],
      optionsJob: [
        { value: 'lead auditor', text: 'Lead Auditor' },
        { value: 'auditor', text: 'Auditor' },
        { value: 'observer', text: 'Observer' },
      ],
      optionstypes: [
        { value: 'onsite', label: 'Onsite' },
        { value: 'overseas', label: 'Overseas' },
      ],
      loader: false,
      validationErrors: {},
      errors: {},
      users: [],
      auditDate: '',
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    return {
      getValidationState,
    }
  },
  computed: {
    optionUser() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
  },
  methods: {
    showBoxForSelected(selectedEngineers) {
      const existingById = new Map((this.usersBox || []).map(u => [u.value, u]))
      this.usersBox = (selectedEngineers || []).map(u => {
        const existing = existingById.get(u.value)
        return {
          ...u,
          job: existing?.job ?? '',
          type: existing?.type ?? null,
        }
      })
      this.syncUsersPayload()
    },
    syncUsersPayload() {
      this.users = (this.usersBox || [])
        .filter(u => u?.value)
        .map(u => ({
          user_id: u.value,
          job: u.job || null,
          type: u.type?.value ?? u.type ?? null,
        }))
    },
    AssignDateAndEng() {
      if (this.$route.params.id) {
        this.loader = true
        const payload = {
          _method: 'PUT',
          date: this.auditDate,
          users: this.users,
        }

        axios
          .post(`audit/${this.$route.params.id}`, payload)
          .then(res => {
            if (res.status === 200) {
              this.$router.push({ name: 'audit-assigned' })
              this.$toasted.show('Updated Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${error.response.data.message}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
